export const navLinks = [
  { id: "overview", label: "作品速览" },
  { id: "about", label: "剧情与主题" },
  { id: "characters", label: "主要人物" },
  { id: "highlights", label: "内容看点" },
  { id: "chapters", label: "内容结构" },
  { id: "watch", label: "观看方式" },
  { id: "faq", label: "常见问题" },
];

export const heroKeywords = [
  "在线观看",
  "完整版",
  "高清播放",
  "无删减在线",
  "免费观看",
  "全集在线",
];

export const quickFacts = [
  {
    icon: "ri-bookmark-3-line",
    label: "作品名称",
    value: "善良的女秘书",
  },
  {
    icon: "ri-price-tag-3-line",
    label: "题材方向",
    value: "都市 · 职场 · 剧情",
  },
  {
    icon: "ri-heart-3-line",
    label: "核心主题",
    value: "善意、坚持与成长",
  },
  {
    icon: "ri-translate-2",
    label: "页面语言",
    value: "简体中文",
  },
  {
    icon: "ri-tv-2-line",
    label: "观看形式",
    value: "在线播放 · 完整版 · 高清",
  },
  {
    icon: "ri-user-heart-line",
    label: "适合人群",
    value: "偏爱都市职场题材的观众",
  },
];

export const aboutParagraphs = [
  "「善良的女秘书」以都市职场为背景，把镜头对准一位在繁忙办公室里默默付出的普通秘书。她并非天生耀眼，却总在别人忽视的细节里多做一步：替同事补上一份遗漏的资料，替团队记住一个被遗忘的承诺。故事正是围绕这些看似微小的善意，慢慢铺开一条关于坚持与选择的成长线。",
  "作品关注的并不是戏剧性的大事件，而是日常里那些容易被略过的瞬间——一句被认真对待的托付、一次不愿随波逐流的坚持。女主角在复杂的职场关系中不断平衡善意与边界，既想帮助身边的人，也要学会保护自己的判断。这种拉扯构成了全片最主要的情感张力。",
  "如果你在寻找在线播放与完整版资源，本页把作品概况、人物关系、内容结构与观看方式集中整理在一处，方便第一次接触这个主题的观众快速了解它讲了什么、适合怎样的心情去看，以及在线观看、高清播放与全集在线分别意味着什么。",
];

export const themePoints = [
  {
    icon: "ri-plant-line",
    title: "善意并非软弱",
    desc: "作品反复讨论一个命题：善良需要分寸。它不回避善意可能被辜负，也强调守住底线的必要，让「善良」不再是简单的好坏标签。",
  },
  {
    icon: "ri-briefcase-4-line",
    title: "真实职场质感",
    desc: "从会议、报告到加班后的空办公室，场景细节贴近真实办公日常，让职场关系有迹可循，而不是悬浮的设定。",
  },
  {
    icon: "ri-women-line",
    title: "女性视角叙事",
    desc: "故事以女主角的观察展开，呈现她如何在被安排与被期待之间，找到自己的表达方式和行动节奏。",
  },
];

export const characters = [
  {
    role: "女主角 · 秘书",
    tag: "核心视角",
    icon: "ri-women-line",
    desc: "故事的中心人物。她细致、耐心，习惯先照顾别人的需要；随着剧情推进，她逐渐学会在善意与自我保护之间找到平衡。",
    traits: ["细心", "温和", "坚韧"],
  },
  {
    role: "直属上司",
    tag: "关键关系",
    icon: "ri-user-star-line",
    desc: "工作中与她接触最多的人，性格严谨、要求高。两人的磨合与理解，是推动女主角成长的一条重要线索。",
    traits: ["严谨", "克制", "要求高"],
  },
  {
    role: "并肩同事",
    tag: "群像支撑",
    icon: "ri-team-line",
    desc: "办公室里的同事群像，性格各异。有人愿意相互扶持，也有人带来压力与难题，共同构成真实的职场氛围。",
    traits: ["多样", "真实", "互动频繁"],
  },
  {
    role: "生活挚友",
    tag: "情感出口",
    icon: "ri-hearts-line",
    desc: "工作之外的朋友，是女主角倾诉与放松的对象。她的出现让故事在职场线之外，多了一层温暖的生活底色。",
    traits: ["直率", "倾听", "支持"],
  },
];

export const filterTags = ["全部", "剧情", "人物", "氛围", "情感", "现实"];

export const highlights = [
  {
    title: "节奏缓而稳",
    tag: "剧情",
    icon: "ri-time-line",
    desc: "故事没有靠密集的冲突推进，而是用日常细节层层累积，让情绪在不知不觉中被带起来。",
  },
  {
    title: "人物动机可信",
    tag: "人物",
    icon: "ri-user-follow-line",
    desc: "每个角色的选择都有来由，即便是不讨喜的配角，也能看清他为什么这样做，避免了脸谱化。",
  },
  {
    title: "办公室空间感",
    tag: "氛围",
    icon: "ri-building-2-line",
    desc: "从工位、走廊到深夜的落地窗，场景调度克制，却把职场的拥挤与孤独感都交代得很清楚。",
  },
  {
    title: "台词留有余味",
    tag: "情感",
    icon: "ri-chat-quote-line",
    desc: "对白不追求金句堆砌，很多情绪藏在没说出口的话里，回看时会发现前后呼应的细节。",
  },
  {
    title: "善意与边界的拉扯",
    tag: "情感",
    icon: "ri-scales-3-line",
    desc: "全片最核心的命题：当善意被一次次消耗，是否还要继续？作品给出了不廉价、也非说教的回应。",
  },
  {
    title: "结尾的克制处理",
    tag: "现实",
    icon: "ri-door-open-line",
    desc: "结局没有落入强行圆满的套路，而是留下一个开放但可信的落点，让观众自己完成情绪收束。",
  },
  {
    title: "职场细节考究",
    tag: "现实",
    icon: "ri-file-list-3-line",
    desc: "文件流转、会议流程、汇报关系等细节相对考究，让职场设定站得住脚，增强代入感。",
  },
  {
    title: "群像关系网络",
    tag: "人物",
    icon: "ri-node-tree",
    desc: "多条人际线彼此交织，主角之外的配角也有自己的处境，构成一张有厚度的关系网。",
  },
];

export const chapters = [
  {
    index: "01",
    title: "开场 · 日常的秩序",
    desc: "以女主角一天的办公日常切入，交代她的工作状态与性格底色，为后文的变化埋下伏笔。",
    badge: "铺垫",
  },
  {
    index: "02",
    title: "转折 · 一件小事",
    desc: "一件看似微不足道的小事打乱了原有节奏，也第一次让她的善意面对现实考验。",
    badge: "起因",
  },
  {
    index: "03",
    title: "冲突 · 被误解",
    desc: "善意未能被理解，她因此陷入争议与自我怀疑，人物关系开始出现明显裂痕。",
    badge: "冲突",
  },
  {
    index: "04",
    title: "选择 · 是否继续",
    desc: "在压力最大的阶段，她必须在随波逐流与坚持本心之间做出明确选择，这是全片的情绪高点。",
    badge: "高潮",
  },
  {
    index: "05",
    title: "收束 · 新的平衡",
    desc: "冲突逐渐缓和，角色各自找到新的位置。故事以克制的方式收尾，留下开放而可信的余味。",
    badge: "收束",
  },
];

export const watchModes = [
  {
    icon: "ri-play-circle-line",
    title: "在线观看",
    desc: "无需额外安装客户端，在本页了解内容后即可按说明进入观看流程，适合想先快速了解再决定的情况。",
    points: ["浏览即用", "入口集中", "先了解后观看"],
  },
  {
    icon: "ri-file-video-line",
    title: "完整版",
    desc: "完整版指内容从开场到结尾保持连贯，不因片段切分而丢失前后铺垫，剧情理解会更顺畅。",
    points: ["叙事连贯", "前后呼应", "理解更完整"],
  },
  {
    icon: "ri-hd-line",
    title: "高清播放",
    desc: "高清播放意味着画面细节更清晰，适合在较大屏幕观看。画质选择通常与网络状况相关，可按需切换。",
    points: ["画面清晰", "大屏友好", "可随网络调整"],
  },
  {
    icon: "ri-scissors-cut-line",
    title: "无删减在线",
    desc: "无删减强调内容保持原始完整度，避免因片段缺失造成的剧情跳跃，观看体验更连贯。",
    points: ["内容完整", "情节不断档", "体验连贯"],
  },
  {
    icon: "ri-gift-line",
    title: "免费观看",
    desc: "本页说明免费观看相关的信息要点，便于初次搜索该主题的用户判断哪些内容可以先行浏览了解。",
    points: ["信息聚合", "降低门槛", "便于了解"],
  },
  {
    icon: "ri-stack-line",
    title: "全集在线",
    desc: "全集在线指内容整体可连续浏览。建议按顺序观看，以免错过人物关系与前期铺垫带来的理解差。",
    points: ["顺序浏览", "关系清晰", "避免跳看"],
  },
];

export const faqs = [
  {
    q: "这个页面具体提供什么内容？",
    a: "本页围绕「善良的女秘书」这一主题，集中整理作品概况、剧情与主题、主要人物、内容看点、内容结构，以及在线观看、完整版、高清播放等观看方式的说明。你可以在一页之内快速了解它讲了什么、适合怎样的观众。",
  },
  {
    q: "在线观看和完整版有什么区别？",
    a: "在线观看强调的是获取方式——不需要额外安装客户端即可开始；完整版强调的是内容完整度——从开场到结尾的叙事保持连贯。两者并不冲突，很多人会先确认是否有完整版，再决定如何在线观看。",
  },
  {
    q: "什么是高清播放，对设备有要求吗？",
    a: "高清播放指画面清晰度更高，更适合在大屏幕设备上观看。清晰度与网络状况相关，网络一般时可选择较低清晰度以保证播放流畅，网络良好时再切换到高清即可。",
  },
  {
    q: "无删减在线是什么意思？",
    a: "「无删减」强调内容保持原始完整度，避免因片段缺失而出现剧情跳跃，让前后铺垫能够顺利衔接。追求完整叙事的观众通常会优先选择无删减版本。",
  },
  {
    q: "全集在线时需要按顺序看吗？",
    a: "建议按顺序观看。作品的前期铺垫与人物关系是逐步建立的，跳看容易错过关键呼应，导致后续情绪与逻辑理解出现偏差。",
  },
  {
    q: "手机端可以正常浏览本页吗？",
    a: "可以。本页对桌面端与移动端都做了适配，图表、卡片与折叠内容在手机上同样清晰可读，导航也可以通过菜单展开使用。",
  },
];

export const watchTips = [
  {
    icon: "ri-wifi-line",
    title: "先确认网络",
    desc: "观看前留意网络稳定度，网络波动较大时优先选择较低清晰度，避免频繁缓冲打断叙事节奏。",
  },
  {
    icon: "ri-headphone-line",
    title: "选择合适的设备",
    desc: "大屏适合欣赏画面细节与空间调度，手机适合碎片时间浏览。按场景选择能让体验更舒适。",
  },
  {
    icon: "ri-list-ordered",
    title: "按顺序观看",
    desc: "剧情依赖前期铺垫，建议从开场看起，保持顺序，才能体会人物关系与情绪递进的变化。",
  },
];

export const footerStats = [
  { value: "11", label: "内容分区" },
  { value: "5", label: "结构阶段" },
  { value: "8", label: "看点条目" },
];